import { render, staticRenderFns } from "./MemberCardModal.vue?vue&type=template&id=6ffc6eda&scoped=true&"
import script from "./MemberCardModal.vue?vue&type=script&lang=js&"
export * from "./MemberCardModal.vue?vue&type=script&lang=js&"
import style0 from "./MemberCardModal.vue?vue&type=style&index=0&id=6ffc6eda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffc6eda",
  null
  
)

export default component.exports